import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "px-16" };
import { computed } from 'vue';
import VueSlider from 'vue-slider-component';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SliderField',
    props: {
        marks: null,
        modelValue: null,
        size: null
    },
    setup(__props) {
        const props = __props;
        const dotStyle = computed(() => {
            return props.size === 'xs'
                ? 'width: 1.4rem; height: 1.375rem; margin-top: 0.25rem'
                : 'width: 2rem; height: 2rem; border-radius: 0.437rem';
        });
        const labelStyle = computed(() => {
            return props.size === 'xs' ? 'font-size: 0.5rem' : 'font-size: 0.875rem; width: 7rem;';
        });
        const railStyle = computed(() => {
            return props.size === 'xs' ? 'height: 1px' : 'height: 2px;';
        });
        const stepStyle = computed(() => {
            return props.size === 'xs'
                ? 'width: 0.25rem; height: 0.25rem; margin-top: -2px'
                : 'width: 0.5rem; height: 0.5rem; margin-top: -3px';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(VueSlider), {
                    "model-value": __props.modelValue,
                    default: 1,
                    min: 1,
                    max: 4,
                    adsorb: true,
                    marks: __props.marks,
                    "dot-style": _unref(dotStyle),
                    "label-style": _unref(labelStyle),
                    "rail-style": _unref(railStyle),
                    "step-style": _unref(stepStyle),
                    tooltip: "none",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:model-value', $event)))
                }, null, 8, ["model-value", "marks", "dot-style", "label-style", "rail-style", "step-style"])
            ]));
        };
    }
});
